// extracted by mini-css-extract-plugin
module.exports = {"root":"LoadMoreObserver_root__2DVem","rootCenter":"LoadMoreObserver_rootCenter__-UwE2","noPaddingBottom":"LoadMoreObserver_noPaddingBottom__KCrc4"};